/**
 * Pantalla de inventario para navegación (screen-registry).
 * Separado de public-api para no cargar InventoryScreen al importar stock/helpers del módulo.
 */
export { InventoryScreen } from './screens/InventoryScreen';
